---
title: "Mid-April Update"
date: "2026-04-16"
---

## <IconHeading icon="Smartphone">Mobile App</IconHeading>

Hourglass is now available on your phone. Review, edit, and export your time entries on the go. <a href="/docs/mobile-overview" target="_blank">Get started with the mobile app</a>.

> **Note:** Mobile access may not be available for all firms. Some firms require a VPN connection, and others may not have mobile access enabled. If you're unsure, check with your firm's admin.

---

## <IconHeading icon="Mail">Outlook Tracking Changes</IconHeading>

We've simplified how email tracking works and added a new way to control how your email time entries are grouped.

**Internal emails are no longer tracked.** Previously this was a per-user toggle — now emails between colleagues at your firm are always filtered out. Emails with at least one external recipient are still tracked normally.

**Email grouping mode** is a new setting that controls how draft and review time on the same email thread gets grouped into entries. Try switching between modes to see how the same thread produces different entries:

<EmailGroupingDemo />

You can change this under <a href="/settings" target="_blank">Settings &gt; Emails</a>.

---

## <IconHeading icon="Video">Meeting Tracking</IconHeading>

Hourglass now tracks time spent in Zoom and Microsoft Teams meetings.

---

## <IconHeading icon="Users">Reporting & Team</IconHeading>

There's a new [Reporting](/reporting) page where you can see insights into your own time. View your hours broken down by client and matter, see daily trends in a bar chart, and filter by date range or status. It's a quick way to check where your time is going without digging through individual entries.

- Hours by client and matter with progress bars
- Daily hours chart showing exported vs. tracked
- Filter by date range, client, matter, or status
- Stat cards for total hours, export rate, and daily average

> **For managers:** If you have direct reports, you'll also see a [Team](/team) tab. Switch the scope to view your team's hours and drill down into any member's entries. From the Team view, you can see their tracked, exported, and calendar pages — and export, edit, delete, duplicate, or combine entries on their behalf.

---

## <IconHeading icon="Type">Abbreviations</IconHeading>

Based on your feedback, abbreviations can now be a mix of uppercase and lowercase letters. Casing is preserved on creation and matched exactly on expansion, so `ab`, `Ab`, and `aB` can be distinct shortcuts that expand to different text.

---

## <IconHeading icon="BookOpen">Documentation</IconHeading>

We've added a [Docs](/docs) page with guides and help articles that we'll keep updated over time. You can access it from your profile menu in the sidebar.

---

## <IconHeading icon="Wrench">Bug Fixes & Stability</IconHeading>

Numerous bug fixes and stability improvements across the application.
